/**
 * Join retry after a 429 (US-LV-26). A venue's Wi-Fi puts a whole room behind a few IPs, so a burst
 * of joins can be refused for seconds; the phone repeats on its own instead of asking the person to
 * tap again. Pure so it is testable without a DOM.
 */
export const JOIN_RETRY_MAX = 6;
const BASE_MS = 1500;
const CAP_MS = 12_000;

/**
 * Wait before retry number `attempt` (0-based): exponential from 1.5 s, capped at 12 s, with
 * "equal jitter" (half fixed, half random) so a room of phones does not retry in lockstep.
 * `random` is injected, in [0, 1).
 */
export function joinBackoffMs(attempt: number, random: number): number {
  const exp = Math.min(CAP_MS, BASE_MS * 2 ** Math.max(0, Math.floor(attempt)));
  const r = Math.min(Math.max(random, 0), 0.999999);
  return Math.round(exp / 2 + (exp / 2) * r);
}

/** Only a 429 is worth repeating; 403 ROOM_FULL, 404 and a refused nickname will not change. */
export function shouldRetryJoin(status: number, attempt: number): boolean {
  return status === 429 && attempt < JOIN_RETRY_MAX;
}
